import featureFlags from "../constants/featureFlags";
import DEFINE, { PATHS } from "./../constants/Define";

export default [
  {
    title: "tours",
    tagSub: "tours",
    exact: false,
    path: PATHS.TOUR.path,
    show: true,
    icon: "faSuitcaseRolling",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.TOUR_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
      {
        title: "warehousemanagement",
        group: "warehousemanagement",
        path: PATHS.WAREHOUSEMANAGEMENT.LIST.path,
        tagSub: "warehousemanagement",
        exac: false,
        icon: "container",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.WAREHOUSEMANAGEMENT,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.VIEW_DETAIL,
        ],
        children: [
          {
            title: "createWarehousemanagement",
            group: "warehousemanagement",
            tagSub: "warehousemanagement",
            path: PATHS.WAREHOUSEMANAGEMENT.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateWarehousemanagement",
            group: "warehousemanagement",
            tagSub: "warehousemanagement",
            path: PATHS.WAREHOUSEMANAGEMENT.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "titleTour",
        group: "tours",
        path: PATHS.TOUR.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "faSuitcaseRolling",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TOUR,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.VIEW_DETAIL,
          DEFINE.GENERAL.PERMISSION.REDEEM,
        ],
        children: [
          {
            title: "createTours",
            group: "tours",
            tagSub: "tours",
            path: PATHS.TOUR.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateTours",
            group: "tours",
            tagSub: "tours",
            path: PATHS.TOUR.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "createTourTickets",
            group: "tours",
            tagSub: "tours",
            path: PATHS.TOUR.TICKET.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateTourTickets",
            group: "tours",
            tagSub: "tours",
            path: PATHS.TOUR.TICKET.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "tour-properties",
        group: "tour-properties",
        tagSub: "tours",
        path: PATHS.TOUR_PROPERTIES.LIST.path,
        exact: false,
        icon: "environment",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.PROPERTY,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createProperties",
            group: "tour-properties",
            tagSub: "tours",
            path: PATHS.TOUR_PROPERTIES.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateProperties",
            group: "tour-properties",
            tagSub: "tours",
            path: PATHS.TOUR_PROPERTIES.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "suppliers",
        group: "suppliers",
        path: PATHS.SUPPLIER.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "faTruck",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.SUPPLIER,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createSuppliers",
            group: "suppliers",
            tagSub: "tours",
            path: PATHS.SUPPLIER.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateSuppliers",
            group: "suppliers",
            tagSub: "tours",
            path: PATHS.SUPPLIER.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "createSupplierProduct",
            group: "suppliers",
            tagSub: "tours",
            path: PATHS.SUPPLIER_PRODUCT.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateSupplierProduct",
            group: "suppliers",
            tagSub: "tours",
            path: PATHS.SUPPLIER_PRODUCT.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "usagePlan",
            group: "suppliers",
            tagSub: "tours",
            path: PATHS.SUPPLIER_PRODUCT.USAGE_PLAN.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "supplierproducts",
        group: "supplierproducts",
        path: PATHS.SUPPLIER_PRODUCT.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "shop",
        show: false,
        routeName: DEFINE.GENERAL.ROUTE_NAME.SUPPLIER_PRODUCT,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [],
      },

      // {
      //   title: "outlets",
      //   group: "fnbOutlet",
      //   tagSub: "tours",
      //   path: PATHS.FNB.OUTLET.LIST.path,
      //   exact: false,
      //   icon: "coffee",
      //   show: false,
      //   routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_OUTLET,
      //   permissions: [
      //     DEFINE.GENERAL.PERMISSION.VIEW,
      //     DEFINE.GENERAL.PERMISSION.UPDATE,
      //     DEFINE.GENERAL.PERMISSION.SYNC,
      //   ],
      // },
      // {
      //   title: "menu",
      //   group: "fnbMenu",
      //   tagSub: "tours",
      //   path: PATHS.FNB.MENU_MANAGER.LIST.path,
      //   exact: false,
      //   icon: "coffee",
      //   show: true,
      //   routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
      //   permissions: [
      //     DEFINE.GENERAL.PERMISSION.VIEW,
      //     DEFINE.GENERAL.PERMISSION.UPDATE,
      //     DEFINE.GENERAL.PERMISSION.SYNC,
      //   ],
      //   children: [
      //     {
      //       title: "Menu",
      //       group: "fnbMenu",
      //       tagSub: "tours",
      //       path: PATHS.FNB.MENU_MANAGER.SUB_MENU.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.SYNC,
      //       ],
      //     },
      //     {
      //       title: "Menu",
      //       group: "fnbMenu",
      //       tagSub: "tours",
      //       path: PATHS.FNB.MENU_MANAGER.SUB_MENU.DETAIL.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.UPDATE,
      //       ],
      //     },
      //   ],
      // },
      // {
      //   title: "fnbProduct",
      //   group: "fnbProduct",
      //   tagSub: "tours",
      //   path: PATHS.FNB.PRODUCT?.LIST?.path,
      //   exact: false,
      //   icon: "coffee",
      //   show: true,
      //   routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT,
      //   permissions: [
      //     DEFINE.GENERAL.PERMISSION.VIEW,
      //     DEFINE.GENERAL.PERMISSION.UPDATE,
      //     DEFINE.GENERAL.PERMISSION.SYNC,
      //   ],
      // },
      // {
      //   title: "condiment",
      //   group: "fnbCondiment",
      //   tagSub: "tours",
      //   path: PATHS.FNB.CONDIMENT_MANAGER.LIST.path,
      //   exact: false,
      //   icon: "coffee",
      //   show: true,
      //   routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
      //   permissions: [
      //     DEFINE.GENERAL.PERMISSION.VIEW,
      //     DEFINE.GENERAL.PERMISSION.UPDATE,
      //     DEFINE.GENERAL.PERMISSION.SYNC,
      //   ],
      //   children: [
      //     {
      //       title: "Condiment",
      //       group: "fnbCondiment",
      //       tagSub: "tours",
      //       path: PATHS.FNB.CONDIMENT_MANAGER.SET_MENU.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.SYNC,
      //       ],
      //     },
      //     {
      //       title: "Condiment",
      //       group: "fnbCondiment",
      //       tagSub: "tours",
      //       path: PATHS.FNB.CONDIMENT_MANAGER.DETAIL.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.UPDATE,
      //       ],
      //     },
      //   ],
      // },
      // {
      //   title: "option",
      //   group: "fnbOption",
      //   tagSub: "tours",
      //   path: PATHS.FNB.OPTION_MANAGER.LIST.path,
      //   exact: false,
      //   icon: "coffee",
      //   show: true,
      //   routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
      //   permissions: [
      //     DEFINE.GENERAL.PERMISSION.VIEW,
      //     DEFINE.GENERAL.PERMISSION.UPDATE,
      //     DEFINE.GENERAL.PERMISSION.SYNC,
      //   ],
      //   children: [
      //     {
      //       title: "Option",
      //       group: "fnbOption",
      //       tagSub: "tours",
      //       path: PATHS.FNB.OPTION_MANAGER.SET_ITEM.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.SYNC,
      //       ],
      //     },
      //     {
      //       title: "Option",
      //       group: "fnbOption",
      //       tagSub: "tours",
      //       path: PATHS.FNB.OPTION_MANAGER.DETAIL.path,
      //       exact: false,
      //       icon: "coffee",
      //       show: false,
      //       routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
      //       permissions: [
      //         DEFINE.GENERAL.PERMISSION.VIEW,
      //         DEFINE.GENERAL.PERMISSION.UPDATE,
      //       ],
      //     },
      //   ],
      // },

      {
        title: "tourTickets",
        group: "tourTickets",
        path: PATHS.TOUR_TICKET.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "faTicketAlt",
        show: false,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TOUR_TICKETS,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createTourTickets",
            group: "tourTickets",
            tagSub: "tours",
            path: PATHS.TOUR_TICKET.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateTourTickets",
            group: "tourTickets",
            tagSub: "tours",
            path: PATHS.TOUR_TICKET.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "objectTypes",
        group: "objectTypes",
        tagSub: "tours",
        path: PATHS.OBJECT_TYPES.LIST.path,
        exact: false,
        icon: "environment",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.OBJECT_TYPES,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createObjectTypes",
            group: "objectTypes",
            tagSub: "tours",
            path: PATHS.OBJECT_TYPES.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateObjectTypes",
            group: "objectTypes",
            tagSub: "tours",
            path: PATHS.OBJECT_TYPES.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "ticketSold",
        group: "ticketSold",
        tagSub: "tours",
        path: PATHS.TICKET_SOLD.LIST.path,
        exact: false,
        icon: "faTicketAlt",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET_SOLD,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          // DEFINE.GENERAL.PERMISSION.CREATE,
          // DEFINE.GENERAL.PERMISSION.UPDATE,
          // DEFINE.GENERAL.PERMISSION.DELETE
        ],
        children: [
          {
            title: "filterdTicketSold",
            group: "ticketSold",
            tagSub: "tours",
            path: PATHS.TICKET_SOLD.LIST_FILTERED_CODE.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "ratecode",
        group: "ratecode",
        path: PATHS.RATECODE.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "container",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.RATE_CODE,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.VIEW_DETAIL,
          DEFINE.GENERAL.PERMISSION.LOCK_ITEM,
        ],
        children: [
          {
            title: "createRateCode",
            group: "ratecode",
            tagSub: "tours",
            path: PATHS.RATECODE.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateRateCode",
            group: "ratecode",
            tagSub: "tours",
            path: PATHS.RATECODE.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "usagePlanRateCode",
            group: "ratecode",
            tagSub: "tours",
            path: PATHS.RATECODE.USAGE_PLAN.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "filterdTicketSold",
        group: "filterdTicketSold",
        tagSub: "tours",
        path: PATHS.TICKET_SOLD.LIST_FILTERED_CODE.path,
        exact: false,
        icon: "faTicketAlt",
        show: false,
      },
      {
        title: "transportation",
        group: "transportation",
        tagSub: "tours",
        exact: false,
        icon: "environment",
        show: false,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TRANSPORTATION,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
      },
      {
        title: "category",
        group: "category",
        path: PATHS.SUPPLIER_CATEGORY.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "appstore",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.SUPPLIER_CATEGORY,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.VIEW_DETAIL,
        ],
        children: [
          {
            title: "createSupplierCategory",
            group: "category",
            tagSub: "tours",
            path: PATHS.SUPPLIER_CATEGORY.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateSupplierCategory",
            group: "category",
            tagSub: "tours",
            path: PATHS.SUPPLIER_CATEGORY.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "categoryvw",
        group: "categoryvw",
        path: PATHS.TAG_GROUP_VW.LIST.path,
        tagSub: "tours",
        exact: false,
        icon: "appstore",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_DETAIL,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.MAP_SKU,
          DEFINE.GENERAL.PERMISSION.VIEW_DETAIL,
        ],
        children: [
          {
            title: "createSupplierCategoryVW",
            group: "categoryvw",
            tagSub: "tours",
            path: PATHS.TAG_GROUP_VW.CREATE.path,
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateSupplierCategoryVW",
            group: "categoryvw",
            tagSub: "tours",
            path: PATHS.TAG_GROUP_VW.DETAIL.path,
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },

      {
        title: "filterdTicketSold",
        group: "filterdTicketSold",
        tagSub: "tours",
        path: PATHS.TICKET_SOLD.LIST_FILTERED_CODE.path,
        exact: false,
        icon: "faTicketAlt",
        show: false,
      },
    ],
  },
];
